import "core-js/modules/es.number.constructor";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createClass";
import _createSuper from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createSuper";
import _inherits from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/inherits";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import AppTextField from '@/components/AppTextField.vue';
import AppSelector from '@/components/AppSelector.vue';
import AppLightModal from '@/components/AppLightModal.vue';
import AppRadio from '@/components/AppRadio.vue';
import { SnackType } from '@/interfaces/snack';
import { showErrors, showNotification } from '@/utils/snack';
import { utcDateTimeToLocal, utcDateTimeToDate } from '@/utils/dateTime';
import { deleteMember } from './gql';

var MemberDialog = /*#__PURE__*/function (_Vue) {
  _inherits(MemberDialog, _Vue);

  var _super = _createSuper(MemberDialog);

  function MemberDialog() {
    var _this;

    _classCallCheck(this, MemberDialog);

    _this = _super.apply(this, arguments);
    _this.targetMember = null;
    _this.utcDateTimeToLocal = utcDateTimeToLocal;
    _this.utcDateTimeToDate = utcDateTimeToDate;
    _this.deleteDialog = {
      show: false,
      title: '删除会员',
      text: ''
    };
    return _this;
  }

  _createClass(MemberDialog, [{
    key: "deleteHandler",
    value: function deleteHandler(item) {
      this.targetMember = item;
      this.deleteDialog.text = "\u662F\u5426\u786E\u5B9A\u5220\u9664\u4F1A\u5458 \u201C".concat(item.nickname, "\u201D ?");
      this.deleteDialog.show = true;
    }
  }, {
    key: "deleteRequest",
    value: function () {
      var _deleteRequest = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this$targetMember, result, typedError;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this.$apollo.mutate({
                  mutation: deleteMember,
                  variables: {
                    memberId: Number((_this$targetMember = this.targetMember) === null || _this$targetMember === void 0 ? void 0 : _this$targetMember.id)
                  }
                });

              case 3:
                result = _context.sent;

                if (result) {
                  showNotification({
                    msg: '删除成功!',
                    type: SnackType.Info
                  });
                }

                this.deleteDialog.show = false;
                _context.next = 12;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](0);
                typedError = _context.t0;
                showErrors(typedError.graphQLErrors);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 8]]);
      }));

      function deleteRequest() {
        return _deleteRequest.apply(this, arguments);
      }

      return deleteRequest;
    }()
  }]);

  return MemberDialog;
}(Vue);

MemberDialog = __decorate([Component({
  components: {
    AppTextField: AppTextField,
    AppSelector: AppSelector,
    AppRadio: AppRadio,
    AppLightModal: AppLightModal
  }
})], MemberDialog);
export default MemberDialog;